<template>
  <div class="menu">
    <div
      class="return"
      @click="close">
      ＜ 返回
    </div>
    <div class="menu-list">
      <van-collapse
        ref="collapseRef"
        v-model="activeNames">
        <nav-bar-menu-item
          v-for="(m, index) in menuList"
          :index="index"
          :border="true"
          :item="m"
          :key="index" />
      </van-collapse>
    </div>
  </div>
</template>

<script>
import NavBarMenuItem from './NavBarMenuItem.vue';
export default {
  components: {
    NavBarMenuItem,
  },
  data() {
    return {
      activeNames: [],
    };
  },
  computed: {
    menuList() {
      return [
        {
          label: '首页',
          underlineFlag: true,
          navColFlg: '',
          idNum: '99',
          routingPath: 'myHome',
          id: '99-1',
        },
      ].concat(this.$store.state.treeList);
    },
  },
  methods: {
    // 关闭
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
$collapse-font-color: #ffffff;
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  .menu {
    width: 345px;
    margin: auto;
    color: #ffffff;

    .return {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      line-height: 15px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      padding: 9px 0px;
    }
  }
  .collapse {
    padding: 0 0 0 20px;

    &-item__wrapper {
      font-weight: 500;
      font-size: 15px;
      color: #ffffff;
      padding: 12px 0;
    }
  }
  ::v-deep .van-collapse {
    &::after {
      border-color: rgba($color: #e2e2e2, $alpha: 0.4);
    }
    .van-collapse-item {
      &--border::after {
        border-color: rgba($color: #e2e2e2, $alpha: 0.4);
        left: 0;
        right: 0;
      }
      &__content {
        background: none;
        color: #ffffff;
        padding: 0;
      }
      .van-cell {
        background: none;
        font-weight: 500;
        font-size: 15px;
        color: #ffffff;
        padding: 12px 0;
        &__right-icon {
          color: #ffffff;
        }
        &::after {
          left: 0;
          right: 0;
          border-color: rgba($color: #e2e2e2, $alpha: 0.4);
        }
      }
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  $container-width: 700px;
  .menu {
    width: $container-width;
    margin: auto;
    color: #ffffff;

    .return {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      line-height: 15px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      padding: 11px 0px;
    }
  }
  .collapse {
    padding: 0 0 0 20px;

    &-item__wrapper {
      font-weight: 500;
      font-size: 15px;
      color: #ffffff;
      padding: 12px 0;
    }
  }
  ::v-deep .van-collapse {
    &::after {
      border-color: rgba($color: #e2e2e2, $alpha: 0.4);
    }
    .van-collapse-item {
      &--border::after {
        border-color: rgba($color: #e2e2e2, $alpha: 0.4);
        left: 0;
        right: 0;
      }
      &__content {
        background: none;
        color: #ffffff;
        padding: 0;
      }
      .van-cell {
        background: none;
        font-weight: 500;
        font-size: 15px;
        color: #ffffff;
        padding: 12px 0;
        &__right-icon {
          color: #ffffff;
        }
        &::after {
          left: 0;
          right: 0;
          border-color: rgba($color: #e2e2e2, $alpha: 0.4);
        }
      }
    }
  }
}
</style>
